<style lang="postcss">
	.select-item {
		padding: 0.17rem 0.75rem;
		position: relative;
		display: flex;
		align-items: flex-start;
		cursor: pointer;
		user-select: none;
	}
	.select-item.shift-right {
		padding-left: 1.4rem;
	}
	.select-item.padding-left {
		padding-left: 1.25rem;
	}
	.select-item-main {
		font-size: 95%;
		font-size: max(95%, 13.5px);
		font-weight: 440;
	}
	.select-item.shift-right .select-item-main {
		font-size: 92%;
		font-size: max(92%, 13.5px);
	}
	.select-item-main.required::after {
		content: "*";
		font-weight: 600;
		color: red;
		margin-left: 0rem;
	}
	.select-item.thick .select-item-main {
		font-weight: 600;
	}
	.select-item.spacious {
		padding: 0.5rem 0.8rem;
	}
	.select-item[aria-selected="true"] {
		z-index: 10;
	}
	.select-item-text {
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 100%;
	}
	.select-item-text.has-description {
		font-size: 95%;
		margin-bottom: -2px;
	}
	.select-item-marker {
		position: absolute;
		left: 0;
		background: currentColor;
		width: 2.5px;
		height: 100%;
		top: 0;
	}
	.select-item-description {
		font-size: 12.5px;
		line-height: 1.35;
		overflow-wrap: break-word;
		opacity: 0.6;
		margin-top: 2px;
	}
</style>

<script lang="ts">
	import { tooltip } from "design/actions/tooltip";
	import Highlight from "$basic/Highlight.svelte";
	import SelectEmbed from "./SelectEmbed.svelte";
	export let item: AllItem;
	export let searchText: string = "";
	export let selected: boolean = false;
	export let multiColumn: boolean = false;
	export let truncate: boolean = false;
	export let hasDescription: boolean = false;
	export let textSize: "sm" | "base" = "base";
	export let paddingLeft = false;
	export let hasGroups = false;
</script>

<div
	role="option"
	data-index="{item.index}"
	class:spacious="{Boolean(hasDescription && item.embed)}"
	style="opacity: {item.disabled ? 0.4 : 1}; border-radius: {multiColumn
		? '3px'
		: '0px'}"
	class:padding-left="{paddingLeft}"
	class:shift-right="{hasGroups && !multiColumn}"
	class="select-item"
	aria-disabled="{Boolean(item.disabled)}"
	aria-selected="{item.focus}">
	<SelectEmbed
		hasDescription="{hasDescription}"
		width="{hasDescription ? '2.1rem' : '1rem'}"
		embed="{item.embed}" />
	<div
		use:tooltip="{{
			delay: 0,
			placement: 'right',
			disabled: !item.meta?.descriptionTooltip,
			content: item.meta?.descriptionTooltip,
			html: true
		}}"
		style="padding: {multiColumn
			? '0.25rem 0'
			: '0 0'}; font-size: {textSize === 'sm'
			? '0.875rem'
			: '1rem'}; display: flex; flex-direction: column; flex: 1 1 0%; min-width: 0">
		<div class="select-item-text" class:has-description="{item.description}">
			<div
				class="select-item-main"
				class:thick="{hasDescription}"
				class:truncate="{truncate}"
				class:required="{item.meta &&
					'required' in item.meta &&
					item.meta.required === true}">
				<Highlight all="{true}" text="{item.label}" query="{searchText}" />
			</div>
			{#if item.meta?.pill}
				<span class="pill sm color" style="margin-left: 0.5rem">
					{item.meta?.pill}
				</span>
			{/if}
			{#if selected && !multiColumn}
				<div class="select-item-marker"></div>
			{/if}
		</div>
		{#if item.description}
			<div class="select-item-description">
				{item.description}
			</div>
		{/if}
	</div>
</div>
